import React from 'react';
import Chart from 'react-apexcharts'

export default function Donut(props: any) {
    const options = {
      colors: ['#28a745', '#dc3545'],
        plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    showAlways: props.showTotal,
                    show: props.showTotal
                  }
                }
              }
            }
          },
          labels: props.labels,
          fill: {
            type: "gradient",
          },
      }
    return (
      <div className="donut">
        <Chart options={options} series={props.series} type="donut" width="380" />
      </div>
    );
}